export var REFUNDS_LIST_PATH = '/refunds/';
export var DISTRIBUTORS_LIST_PATH = '/distributors/';
export var DISTRIBUTOR_CREATE_PATH = '/distributors/create';
export var PRODUCTS_LIST_PATH = '/products/';
export var PRODUCTS_CREATE_PATH = "".concat(PRODUCTS_LIST_PATH, "new");
export var PRODUCTS_EDIT_PATH = "".concat(PRODUCTS_LIST_PATH, ":identifier/modify");
export var getProductEditPath = function getProductEditPath(identifier) {
    return "".concat(PRODUCTS_LIST_PATH).concat(identifier, "/modify");
};
